import { render, staticRenderFns } from "./destaques.sistema.vue?vue&type=template&id=a3e40722&scoped=true&"
import script from "./destaques.sistema.vue?vue&type=script&lang=js&"
export * from "./destaques.sistema.vue?vue&type=script&lang=js&"
import style0 from "./destaques.sistema.vue?vue&type=style&index=0&id=a3e40722&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e40722",
  null
  
)

export default component.exports